import http from "@/http/http"

interface AreaOverallArgs {
  // 区域编码
  areaCode: number
  // 街道/镇编码（全部街道时不传）
  townshipCodes?: number[]
  // 园区ID
  id?: string
}

export interface DistributionItemVO {
  id: string
  // 标签
  name: string
  // 占比
  ratio: number
}

interface TownshipEconomyItemVO {
  label: string
  ratio: number
  total: number
}

interface EnterpriseTrendsItemVO {
  // 年度
  year: number
  // 数量
  count: number
  // 增长率
  ratio: number
}

export interface MonthPopulationItemVO {
  // 月份
  month: string
  // 人口数量
  value: number
}

export interface AreaOverallResult {
  // 人口流量趋势分析
  populationFLow: {
    // 总客流峰时时段
    totalUvHour: string
    // 工作日客流人数
    workdayUv: number
    // 周末客流人数
    weekendUv: number
  }
  // 人口画像
  populationProfile: {
    // 常驻人口
    residentPopulation: number
    // 户籍人口
    registeredPopulation: number
    // 外来常驻人口
    externalPopulation: number
    // 到访人口情况
    visitPopulationItems: MonthPopulationItemVO[]
    // 常驻人口情况
    residentPopulationItems: MonthPopulationItemVO[]
    // 工作人口情况
    workPopulationItems: MonthPopulationItemVO[]
    // 居住人口情况
    livingPopulationItem: MonthPopulationItemVO[]
    // 性别分布
    genderDistribution: DistributionItemVO[]
    // 年龄分布
    ageDistribution: DistributionItemVO[]
    // 消费水平
    consumptionDistribution: DistributionItemVO[]
    // 职业分布
    occupationDistribution: DistributionItemVO[]
  }
  // 街道经济排行
  townshipEconomyItems: TownshipEconomyItemVO[]
  // 经济状态
  economyStatus: {
    // 企业经营
    enterpriseManage: {
      // 数据年度
      year: number
      // 续存企业数量
      renewEnterprise: number
      // 注销企业数量
      cancelEnterprise: number
      // 吊销企业数量
      revokeEnterprise: number
    }
    // 企业趋势
    enterpriseTrendsItems: EnterpriseTrendsItemVO[]
  }
}

// 获取区域概况
export async function getAreaOverall(args: AreaOverallArgs): Promise<AreaOverallResult> {
  try {
    const result = await http.post<AreaOverallResult>("/cityFeature/areaOverall", args)
    return result?.data
  } catch (error) {
    throw error
  }
}

interface ParksArgs {
  // 区域编码
  areaCode: number
  // 街道/镇编码（全部街道时不传）
  townshipCodes?: number[]
}

export interface ParkItemVO {
  id: string
  name: string
  // 经度
  longitude: number
  // 纬度
  latitude: number
  // aoi围栏
  polygon: number[][]
}

// 获取园区列表
export async function getParks(args: ParksArgs): Promise<ParkItemVO[]> {
  try {
    const result = await http.post<ParkItemVO[]>("/cityFeature/areaOverall/parks", args)
    return result?.data
  } catch (error) {
    throw error
  }
}

interface EconomicYearsArgs {
  // 区域编码
  areaCode: number
  // 街道/镇编码（全部街道时不传）
  townshipCodes?: number[]
}

// 获取经济状态年份列表
export async function getEconomicYears(args: EconomicYearsArgs): Promise<string[]> {
  try {
    const result = await http.post<string[]>(
      "/cityFeature/areaOverall/enterprise/economy/years",
      args,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}

interface EnterpriseEconomyArgs {
  // 区域编码
  areaCode: number
  // 街道/镇编码（全部街道时不传）
  townshipCodes?: number[]
  // 年份
  year?: string
}

interface EnterpriseEconomyResult {
  // 企业经营
  enterpriseManage: {
    // 数据年度
    year: number
    // 续存企业数量
    renewEnterprise: number
    // 注销企业数量
    cancelEnterprise: number
    // 吊销企业数量
    revokeEnterprise: number
  }
  // 企业趋势
  enterpriseTrendsItems: EnterpriseTrendsItemVO[]
}

// 获取经济状态数据
export async function getEnterpriseEconomy(
  args: EnterpriseEconomyArgs,
): Promise<EnterpriseEconomyResult> {
  try {
    const result = await http.post<EnterpriseEconomyResult>(
      "/cityFeature/areaOverall/enterprise/economy",
      args,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}
